import {createRequest, makeRequest, prepareRequest} from "../utils/apiUtil";

export function getAll(filters = {}, includes = [], extraParams = {}) {
    return makeRequest(createRequest('facility'), prepareRequest(filters, includes, extraParams));
}

export function getRentalTerms(id, start, end) {
    return makeRequest(createRequest('facility/' + id + '/term?start=' + start + '&end=' + end));
}